import React from 'react';
import PropTypes from 'prop-types';
import * as R from 'ramda';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';

const FiltersByDate = ({ appliedFilters, cardsFilters, setCardsFilters, onClearFilters }) => {
  // prettier-ignore
  const handleFilterChange = filter => R.compose(
    setCardsFilters,
    R.assoc(filter),
    R.path(['target', 'value'])
  );

  return (
    <>
      <TextField
        fullWidth
        label="Driver"
        name="Driver"
        onChange={handleFilterChange('driver')}
        value={cardsFilters.driver}
      />

      <FormControl fullWidth>
        <InputLabel id="filter-status">Status</InputLabel>
        <Select
          label="Status"
          labelId="filter-status"
          onChange={handleFilterChange('status')}
          value={cardsFilters.status}
        >
          <MenuItem value="All">All</MenuItem>
          <MenuItem value="Draft">Draft</MenuItem>
          <MenuItem value="Pending">Pending</MenuItem>
          <MenuItem value="Scheduled">Scheduled</MenuItem>
          <MenuItem value="Warning">Warning</MenuItem>
          <MenuItem value="Completed">Completed</MenuItem>
        </Select>
      </FormControl>

      <TextField
        fullWidth
        label="Trailer ID"
        name="vaporTightnessCode"
        onChange={handleFilterChange('vaporTightnessCode')}
        value={cardsFilters.vaporTightnessCode}
      />

      <TextField
        fullWidth
        label="PO Number"
        name="poNumber"
        onChange={handleFilterChange('poNumber')}
        value={cardsFilters.poNumber}
      />

      {Boolean(appliedFilters.length) && (
        <Button onClick={onClearFilters} variant="text">
          Clear
        </Button>
      )}
    </>
  );
};

FiltersByDate.propTypes = {
  appliedFilters: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  cardsFilters: PropTypes.shape({
    driver: PropTypes.string,
    poNumber: PropTypes.string,
    status: PropTypes.oneOf(['All', 'COMPLETED', 'DRAFT', 'PENDING', 'SCHEDULED', 'WARNING']),
    vaporTightnessCode: PropTypes.string,
  }).isRequired,
  onClearFilters: PropTypes.func.isRequired,
  setCardsFilters: PropTypes.func.isRequired,
};

export default FiltersByDate;
